// extracted by mini-css-extract-plugin
export default {"itemCtn":"SkillsItem_itemCtn__tiKBm","itemData":"SkillsItem_itemData__V2xIq","skillLabel":"SkillsItem_skillLabel__hkIAh","skillListItem":"SkillsItem_skillListItem__22sIz"};